import styled from 'styled-components';

const ModalContent = styled.div`
	display: flex;
	height: 100%;
	padding: 15px;
	align-items: center;
	flex-direction: column;
	justify-content: center;
`;

const Input = styled.input`
	flex: 1;
	border: none;
	font-size: 30px;
	font-weight: 700;
	caret-color: ${p => p.theme.colors.green};
`;

const Info = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border: 2px solid #2dc27e;
	border-radius: 82.4595px;
	width: 230px;
	height: 37px;
	margin: 0 10px;
`;

const Button = styled.button`
	background-color: ${p => p.theme.colors.green};
	border-radius: 20px;
	width: 134px;
	height: 37px;
`;

const Close = styled.button`
	background-color: transparent;
	position: absolute;
	top: 12px;
	right: 15px;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	ModalContent,
	Input,
	Info,
	Button,
	Close,
};
